import FetchService from "./Shared/FetchService";
const advisorURL = "/aviso/advisor";
export default class TestScoreService {
    static getTestScores(affiliationId) {
        return FetchService.get(advisorURL + "/getTestScores", { affiliationId });
    }
}
